<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12>
        <HistoryList :history="historyList" />
      </v-flex>
      <v-flex v-if="totalPages && totalPages > 1" xs12 text-xs-center pt-4>
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          :disabled="busy"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import HistoryList from '../components/History/HistoryList.vue';

export default {
  name: 'history',
  components: {
    HistoryList,
  },
  data: () => ({
    page: 1,
    busy: false,
  }),
  computed: {
    ...mapGetters('history', [
      'historyList',
      'totalPages',
      'query',
    ]),
    currentPage: {
      get() {
        return parseInt(this.$route.params.page, 0);
      },
      set(page) {
        this.$router.push({ path: `/historia/${page}`, query: this.query });
      },
    },
  },
  methods: {
    ...mapActions('history', [
      'getUsersList',
      'setQuery',
    ]),
    getList() {
      const { query, params } = this.$route;
      this.setQuery(query);
      this.getUsersList(params.page);
    },
  },
  beforeDestroy() {
    this.setQuery(null);
  },
  mounted() {
    this.getList();
  },
  watch: {
    $route() {
      this.getList();
    },
  },
};
</script>
